import Headings from "components/Headings"
import style from "components/IconGrid.module.scss"
import { motion, useTransform, useViewportScroll } from "framer-motion"
import Img from "gatsby-image"
import { useStores } from "hooks/useStores"
import { rootVariants } from "lib/constants"
import { observer } from "mobx-react"
import React, { useLayoutEffect, useRef, useState } from "react"
import { useInView } from "react-intersection-observer"
import { useCallbackRef } from "use-callback-ref"

const IconGrid = ({ heading, icons }) => {
  const { uiStore } = useStores()

  const [elementHeight, setElementHeight] = useState(0)
  const [itemYPosition, setItemYPosition] = useState(0)

  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    threshold: 0.5
  })

  const iconsRef = useRef(null)

  // Set the scroll position to left
  const iconsWrapperRef = useCallbackRef(null, ref => {
    if (ref)
      setItemYPosition(
        window.pageYOffset + iconsRef.current.getBoundingClientRect().top
      )
  })

  const { scrollY } = useViewportScroll()
  const y = useTransform(
    scrollY,
    [itemYPosition - elementHeight, itemYPosition + elementHeight],
    ["25%", "-25%"]
  )

  useLayoutEffect(() => {
    const element = iconsRef.current
    const { height } = element.getBoundingClientRect()

    setElementHeight(height)
  }, [])

  return (
    <motion.div
      className={style.root}
      ref={ref}
      variants={rootVariants}
      initial="initial"
      animate={inView ? "animate" : "initial"}
      exit="exit"
    >
      <div className={style.content}>
        <div className={style.header}>
          <div className={style.headings}>
            <Headings mainHeading={heading} />
          </div>
        </div>
        <motion.a
          href="https://www.coursera.org/about/partners"
          target="_blank"
          rel="noreferrer"
          className={style.iconsWrapper}
          ref={iconsWrapperRef}
        >
          <ul className={style.icons} ref={iconsRef} style={{ y }}>
            {icons.map((icon, index) => {
              return (
                <li key={`${icon.id}-${index}`} className={style.icon}>
                  <div className={style.image}>
                    {!!icon && (
                      <Img
                        placeholderStyle={{ visibility: "hidden" }}
                        fluid={icon.fluid}
                      />
                    )}
                  </div>
                </li>
              )
            })}
          </ul>
        </motion.a>
      </div>
    </motion.div>
  )
}

export default observer(IconGrid)
